'use strict';
import {OrganizationViewMembersHeader} from './components/OrganizationViewMembersHeader';
import {OrganizationDomainProvider} from './domain/OrganizationDomain';
import {OrganizationInviteAccessCodeDomainProvider} from './domain/OrganizationInviteAccessCodeDomain';
import {OrganizationInviteDomainProvider} from './domain/OrganizationInviteDomain';
import {OrgMemberDomainProvider} from './domain/OrgMemberDomain';
import {UserInviteDomainProvider} from './domain/UserInviteDomain';

const angular = require('angular');


module.exports = angular
  .module('app.organizations', [])
  .constant('INVITE_STATUS', require('./enums/INVITE_STATUS.js'))

  .provider('OrganizationDomain', OrganizationDomainProvider)
  .provider('OrganizationInviteAccessCodeDomain', OrganizationInviteAccessCodeDomainProvider)
  .provider('OrganizationInviteDomain', OrganizationInviteDomainProvider)
  .provider('OrgMemberDomain', OrgMemberDomainProvider)
  .provider('UserInviteDomain', UserInviteDomainProvider)
  .directive('organizationViewMembersHeader', ['reactDirective', reactDirective =>
    reactDirective(OrganizationViewMembersHeader),
  ])
;



// WEBPACK FOOTER //
// ./src/js/organizations/index.js